import module from 'contabilidad/polizasexternas/module'
import template from './template.html'

export class contabilidadPolizasexternasAlgodonerosPolizaIngresosLista {

  constructor(PolizasExternasAlgodonerosPolizaIngresos, $filter, $file) {
    this.PolizasExternasAlgodonerosPolizaIngresos = PolizasExternasAlgodonerosPolizaIngresos
    this.$filter = $filter
    this.$file = $file
    this.verificarCadena = $filter('rPad')
  }

  $onInit() {
    this.promise = this.PolizasExternasAlgodonerosPolizaIngresos.get(this.busqueda.fechaInicial, this.busqueda.fechaFinal)
      .then((resolve) => {
        this.data = resolve.data.informacion
      })

  }

  descargar() {
    let poliza = this.filtrarDatos(this.data)
    let texto = this.codificar(poliza, 1)
    let fecha = this.$filter('date')(new Date(), 'yyyyMMdd')
    let blob = new File([texto], { type: 'text/plain;' })
    this.$file.saveAs(blob, 'PolizaIngresos_' + fecha + '.txt')
  }

  codificar(data, inicio_poliza) {
    let cadena = '',
      cadA = 'P  AAAAMMDD    1      JJJJ 1 0          ' +
        'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\r\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \r\n'

    console.log('data', data);
    data.forEach((item, index) => {
      let titulo = this.verificarCadena('Ingresos del dia ' + this.$filter('date')(item[0].fecha, 'dd-MM-yyyy'), 60)
      cadena += cadA
        .replace('AAAAMMDD', this.$filter('date')(item[0].fecha, 'yyyyMMdd'))
        .replace('JJJJ', ('000' + (index + 1)).slice(-4))
        .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', titulo)

      item.forEach(registro => {
        cadena += cadB
          .replace('CCCCCCCCCCCCCCCC', this.verificarCadena(registro.cuentaContableBanco.replace(/-/g, ''), 16))
          .replace('ZZZZZZZZZZZZZZZ', this.verificarCadena(this.$filter('date')(registro.fecha, 'dd/MM/yyyy'), 15))
          .replace('*', 0)
          .replace('YYYYYYYYY', this.verificarCadena((parseFloat(Math.abs(registro.importe)).toFixed(2)), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', this.verificarCadena(registro.filtro, 43))

        registro.facturas.forEach((detalle) => {
          if (detalle.importe > 0) {
            cadena += cadB
              .replace('CCCCCCCCCCCCCCCC', this.verificarCadena(detalle.cuentaContable.replace(/-/g, ''), 16))
              .replace('ZZZZZZZZZZZZZZZ', this.verificarCadena(detalle.factura, 15))
              .replace('*', detalle.naturaleza == '1' ? 1 : 0)
              .replace('YYYYYYYYY', this.verificarCadena((parseFloat(Math.abs(detalle.importe)).toFixed(2)), 9))
              .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', this.verificarCadena((detalle.descripcion), 43))
          }
        })
      })
    })

    return cadena
  }

  filtrarDatos() {
    let arreglo = []
    let general = this.data.filter((registro) => registro.descripcion !== 'TIENDA EN LINEA')
    if (general.length) {
      arreglo.push(general)
    }

    let tienda = this.data.filter((registro) => registro.descripcion === 'TIENDA EN LINEA')
    if (tienda.length) {
      arreglo.push(tienda)
    }

    return arreglo
  }
}

module.component('contabilidadPolizasexternasAlgodonerosPolizaIngresosLista', {
  controller: contabilidadPolizasexternasAlgodonerosPolizaIngresosLista,
  template,
  bindings: {
    busqueda: '<',
  },
})




// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/algodoneros/poliza-ingresos/lista/component.js